// @flow

import type {Language, ModalProps} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appSelectors, portfoliosActions, uiActions} from '@/store'

type Props = {
  setupPortfolioListForm: () => void,
  copyCompanies: () => void,
  showEditModal: (props: ModalProps) => void,
  l: Language,
  disabled: boolean,
}

const RawCopyButton = (props: Props) =>
  <button id='copy_button'
    className="btn btn-success"
    disabled={props.disabled}
    onClick={() => {
      props.setupPortfolioListForm()
      props.showEditModal({
        title: 'Copy companies to',
        onConfirm: props.copyCompanies,
      })
    }}
  >
    {props.l('Copy')}
  </button>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawCopyButton)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/copy-button.js